import background from "shared/assets/img/background.jpg"
import cls from "./Title.module.scss"

export const Title = () => {
    return (
        <div>
            {/* <img className={cls.background} src={background} alt="background"></img> */}
            <h1 className={cls.title}>Привет! Я <div className={cls.gradient}>frontend</div> разработчик из города Москвы</h1>
        </div>
    )
}